import React, { useState } from "react";
import { Camera, X, ChevronLeft, ChevronRight } from "lucide-react";

import img01 from "../../assets/gallery/01-acilis.jpg";
import img02 from "../../assets/gallery/02-takim-calismasi.jpg";
import img03 from "../../assets/gallery/03-kapsul-turu.jpg";
import img04 from "../../assets/gallery/04-acilis-konusmasi.jpg";
import img05 from "../../assets/gallery/05-proje-gelistirme.jpg";
import img06 from "../../assets/gallery/06-mentor-gorusmesi.jpg";
import img07 from "../../assets/gallery/07-proje-sunumlari.jpg";
import img08 from "../../assets/gallery/08-juri-sunumlari.jpg";
import img09 from "../../assets/gallery/09-juri-degerlendirmesi.jpg";
import img10 from "../../assets/gallery/10-birincilik-odulu.jpg";
import img11 from "../../assets/gallery/11-odul-toreni.jpg";
import img12 from "../../assets/gallery/12-toplu-fotograf.jpg";

const galleryImages = [
  { id: 1, src: img01, alt: "Hackathon açılış ve tanıtım sunumu", caption: "Açılış ve Tanıtım" },
  { id: 2, src: img08, alt: "Etkinlik başlangıç sunumu", caption: "Etkinlik Başlangıcı" },
  { id: 3, src: img04, alt: "Açılış konuşması yapılıyor", caption: "Açılış Konuşması" },
  { id: 4, src: img03, alt: "Kapsül Teknoloji Platformu turu", caption: "Kapsül Teknoloji Turu" },
  { id: 5, src: img02, alt: "Katılımcılar takım halinde çalışıyor", caption: "Takım Çalışması" },
  { id: 6, src: img05, alt: "Katılımcılar proje geliştirme sürecinde", caption: "Proje Geliştirme" },
  { id: 7, src: img06, alt: "Mentor katılımcılarla görüşüyor", caption: "Mentor Görüşmesi" },
  { id: 8, src: img07, alt: "Takım proje sunumunu yapıyor", caption: "Proje Sunumları" },
  { id: 9, src: img09, alt: "Etkinlik anından bir görüntü", caption: "Etkinlik" },
  { id: 10, src: img10, alt: "Birincilik ödülü takdim ediliyor", caption: "Birincilik Ödülü" },
  { id: 11, src: img11, alt: "Tüm kazananlar ödül töreni", caption: "Ödül Töreni" },
  { id: 12, src: img12, alt: "Tüm katılımcılar toplu fotoğraf", caption: "Toplu Fotoğraf" },
];

export const GallerySection: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const openLightbox = (index: number) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);

  const goNext = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex((selectedIndex + 1) % galleryImages.length);
    }
  };

  const goPrev = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (selectedIndex !== null) {
      setSelectedIndex(
        (selectedIndex - 1 + galleryImages.length) % galleryImages.length
      );
    }
  };

  return (
    <section id="gallery" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gray-50 px-5 py-2 rounded-lg mb-4 border border-gray-200">
            <Camera className="w-5 h-5 text-gray-700" />
            <span className="text-xs font-semibold text-gray-700 tracking-wide uppercase">
              Galeri
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4">
            Etkinlik Fotoğrafları
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            29-30 Ocak 2026 tarihlerinde gerçekleştirilen Su Hackathonu'ndan
            kareler
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300"
              onClick={() => openLightbox(index)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />

              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />

              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300">
                <p className="text-white text-sm font-medium">
                  {image.caption}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            className="absolute top-6 right-6 text-white/80 hover:text-white transition z-10"
            onClick={closeLightbox}
          >
            <X className="w-8 h-8" />
          </button>

          <button
            className="absolute left-4 sm:left-8 text-white/60 hover:text-white transition z-10"
            onClick={goPrev}
          >
            <ChevronLeft className="w-10 h-10" />
          </button>

          <button
            className="absolute right-4 sm:right-8 text-white/60 hover:text-white transition z-10"
            onClick={goNext}
          >
            <ChevronRight className="w-10 h-10" />
          </button>

          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={galleryImages[selectedIndex].src}
              alt={galleryImages[selectedIndex].alt}
              className="w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-center text-white/80 text-base font-medium mt-4">
              {galleryImages[selectedIndex].caption}
            </p>
          </div>
        </div>
      )}
    </section>
  );
};
